import React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import store from './redux/store';
import {addPage, changePropertiesById2, loadSettings, setPageState} from './redux/actions';
import {Header} from './components';
import Container from './components/Container';
import Footer from './components/Footer';
import objeler from './components/objeler';
import {Redirect, withRouter} from 'react-router-dom'
import Loader from './react-fullpage-custom-loader/dist/index'
import {PageSize, SetGrid} from './components/Functions/funcs'
import axiosInstance from './components/token/axiosInstance'
import axios from "axios";
import { Beforeunload } from '../src/react-beforeunload/dist/react-beforeunload';
import TemplateLibrary from './templates/components/TemplateLibrary';
import V2Dashboard from './v2/components/V2Dashboard';
require('dotenv').config();
type Props = {
    initializeApp: () => void,
    tools: [],
    activeElement: { properties: {} }
};

class Frame extends React.Component<Props> {
    constructor(props) {
        super(props);
        objeler['App'] = this;
        objeler['EditorEnter'] = false;
        const gridsize = 5;
        const grds = SetGrid(gridsize);
        this.state = {
            Pages: [],
            zoomScale: 'scale(1,1)',
            scale: 1,
            activePage: 1,
            activePageScroll: 1,
            window: {width: 0, height: 0},
            DocName: '',
            ShowLoader: false,
            LoaderText: [''],
            GridLines: grds.grd,
            GridSize: grds.sz,
            EditorProps: {
                ShowRuler: true,
                ShowGridLines: true,
                ShowPageNumber: true,
                GridSize: gridsize
            }
        };
        this.props.setPageState(this.state.Pages);
        objeler['EditorProps'] = this.state.EditorProps;
        objeler['ChangeDocName'] = this.ChangeDocName;
        this.GetActivePage = this.GetActivePage.bind(this);
        this.SetPagePreferences = this.SetPagePreferences.bind(this);
        objeler['GetActivePage'] = this.GetActivePage;
        objeler['SetPagePreferences'] = this.SetPagePreferences;
        //window.addEventListener("beforeunload", this.logout )

    }
    logout(){

        if (!objeler.hasOwnProperty("User")) return

        console.log('logout', objeler)
        axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/login/Logout', null
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                //responseType: 'arraybuffer'
            }
        ).then((response) => {
            console.log('RES',response,store.getState().appReducers.SessionId)
            if (response.data==='dublicate'){
                sessionStorage.clear();
                objeler.User = null;
                this.history.push({
                    pathname: '/'
                    , state: {redir: true}
                })
            }

        }).catch((error) => {

            sessionStorage.clear();
            objeler.User = null;
            this.history.push({
                pathname: '/'
                , state: {redir: true}
            })
        })
    }
    SetPagePreferences(e, e2) {
        objeler.ModalPageParameters.id
        const pgs = this.state.Pages.slice();
        pgs[objeler.ModalPageParameters.id - 1].Continuous = objeler.ModalPageParameters.Continuous;
        pgs[objeler.ModalPageParameters.id - 1].ContinuousHeader = objeler.ModalPageParameters.ContinuousHeader;
        pgs[objeler.ModalPageParameters.id - 1].ContinuousTemplate = objeler.ModalPageParameters.ContinuousTemplate;
        pgs[objeler.ModalPageParameters.id - 1].ShowEmptyPage = objeler.ModalPageParameters.ShowEmptyPage;
        // FIX-MP-FOOTER-CFG: Modal'dan gelen FooterZoneHeight'ı Pages state'ine aktar
        if (objeler.ModalPageParameters.hasOwnProperty("FooterZoneHeight")) {
            pgs[objeler.ModalPageParameters.id - 1].FooterZoneHeight = objeler.ModalPageParameters.FooterZoneHeight;
        }
        this.setState({Pages: pgs})
    }

    GetActivePage(e) {
        let pg = this.state.activePageScroll - 1;
        if (e != undefined) {
            pg = e - 1;
        }
        return this.state.Pages[pg];
    }

    ChangeDocName(e) {
        this.App.setState({DocName: e}, () => {
        });
    }

    ShowLoader(e, text) {
        this.setState({ShowLoader: e, LoaderText: text}, () => {
        })
    }

    LoadPage(e) {
        for (let prp in e) {
            if (!e[prp].hasOwnProperty("Continuous"))
                e[prp].Continuous = false;
            if (!e[prp].hasOwnProperty("ContinuousHeader"))
                e[prp].ContinuousHeader = false;
            if (!e[prp].hasOwnProperty("ContinuousTemplate"))
                e[prp].ContinuousTemplate = false;
            if (!e[prp].hasOwnProperty("ShowEmptyPage"))
                e[prp].ShowEmptyPage = false;
            // FIX-MP-FOOTER-CFG: eski dokümanlarda FooterZoneHeight yoksa default 60
            if (!e[prp].hasOwnProperty("FooterZoneHeight"))
                e[prp].FooterZoneHeight = 60;
        }
        this.setState({Pages: e}, () => {
            this.props.setPageState(this.state.Pages);
        });
    }

    preventBrowserFullScreen = (e) => {
    };
    updateDimensions = () => {
        this.setState({window: {width: window.innerWidth, height: window.innerHeight}});
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        document.addEventListener("keydown", e => this.preventBrowserFullScreen(e));
    }

    componentDidMount = () => {
        document.addEventListener("keydown", e => this.preventBrowserFullScreen(e));
        window.addEventListener('resize', this.updateDimensions);
        objeler['scale'] = 1;
        require('dotenv').config();
        const {initializeApp} = this.props;
        initializeApp();
        this.addNewPage(-1);
        this.setState({User: {Id: 1, Name: 'tarik', Password: '123'}, DocName: 'NewDoc'}, () => {
            objeler['DocName'] = this.state.DocName;
        });
    };
    clearDocument = () => {
        alert("cleeeear");
        const {initializeApp} = this.props;
        initializeApp();
    }
    deleteNewPage = (pg) => {
        console.log('deletepage', this.state.activePageScroll, pg)
        if (pg < 0 || pg == undefined)
            pg = this.state.activePageScroll;
        const {alert} = objeler.Editor.props;
        alert.success("Page " + pg + " will be deleted.Are you sure you want to remove it?", true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.deleteNewPageOK(pg)
                        },
                    }
                ]
            }
        );
    }
    deleteNewPageOK = (pg) => {
        console.log('DELETE', pg, this.state.activePage);
        const objects = store.getState().appReducers.objects;
        var newObj = {};
        for (let prop in objects) {
            if (pg == objects[prop].PageId) {
                newObj = {...newObj, [objects[prop].id]: objects[prop]};
            }
        }
        objeler.Editor.props.dropElementBulk(newObj);
        var arr = this.state.Pages.filter((item) => item.id !== pg);
        console.log('this.state.Pages', this.state.Pages);
        console.log('new', arr.length);
        this.setState({Pages: arr}, () => {
            this.ReOrganiseAfterDelete(pg, -1);
            this.props.setPageState(this.state.Pages);
        });
        console.log('new', arr);
    }
    ReOrganiseAfterDelete = (pageid, increment) => {
        const objects = store.getState().appReducers.objects;
        for (let prop in objects) {
            if (objects[prop].PageId > pageid) {
                objects[prop].PageId = objects[prop].PageId + increment;
            }
        }
        if (increment < 0) {
            const pages = this.state.Pages;
            for (let prop in pages) {
                if (pages[prop].id > pageid) {
                    pages[prop].id = pages[prop].id - 1;
                }
            }
            this.setState({Pages: pages}, () => {
                this.props.setPageState(this.state.Pages);
            });
        }
    }
    resetPage = (page) => {
        const id = 1;
        this.setState({
            Pages: [{
                id: id,
                text: "Button " + id,
                onClick: () => alert("You clicked to button " + id),
                width: PageSize().Width,
                height: PageSize().Height,
                Continuous: false,
                ContinuousHeader: false,
                ContinuousTemplate: false,
                ShowEmptyPage: false,
                FooterZoneHeight: 60  // FIX-MP-FOOTER-CFG
            }
            ]
        }, () => {
            this.props.setPageState(this.state.Pages);
        });
    }
    onChangeEditorProps = (prp) => {
        if (prp.GridSize != this.state.EditorProps.GridSize)
            this.SetGrid(prp.GridSize);
        this.setState({EditorProps: prp}, () => {
            objeler['EditorProps'] = this.state.EditorProps;
        });
    }
    addNewPage = (page) => {
        // console.log('addNewPage', this.state.Pages.length);
        const id = this.state.Pages.length + 1;
        let arr = [...this.state.Pages];
        arr.splice(this.state.activePage - 1, 0,
            {
                id: id,
                text: "Button " + id,
                onClick: () => alert("You clicked to button " + id),
                width: PageSize().Width,
                height: PageSize().Height,
                Continuous: false,
                ContinuousHeader: false,
                ContinuousTemplate: false,
                ShowEmptyPage: false,
                FooterZoneHeight: 60  // FIX-MP-FOOTER-CFG: default footer zone height in pt
            });
        for (let idx = 0; idx < arr.length; idx++) {
            arr[idx].id = idx + 1;
        }
        this.setState({
                Pages: arr
            }
            , () => {
                this.props.setPageState(this.state.Pages);
            }
        );
        if (page > 0) {
            this.ReOrganiseAfterDelete(this.state.activePage - 1, 1);
        }
    };
    logout = () => {
        objeler['User'] = null;
    }
    setFooterText = (text) => {
        this.setState({footerText: text}, () => {
        })
    }
    SetGrid = (e) => {
        const grds = SetGrid(e);
        this.setState({GridLines: grds.grd, GridSize: grds.sz})
        ;
    }
    ZoomIn = (e) => {
        objeler.Editor.ResetLocation();
        var xx = 0;
        if (e > 0) {
            xx = parseFloat(this.state.scale) + 0.1;
        }
        if (e < 0) {
            xx = parseFloat(this.state.scale) - 0.1;
        }
        if (e === 0) {
            xx = 1;
        }
        xx = parseFloat(xx).toFixed(1);
        this.setState({scale: xx});
        objeler.scale = xx;
    }
    render = () => {
        const {tools, activeElement} = this.props;
        var fromUrl = "";
        try {
            fromUrl = this.props.location.state.fromUrl
        } catch {
            this.props.history.push('/');
        }
        if (fromUrl != 'Login')
            return (<Redirect to={{pathname: '/'}}/>)
        else
            return (
                <div className="flex flex-col h-full flex-1" style={{
                    userSelect: 'none'
                }}>
                    <Beforeunload onBeforeunload={() => 'You’ll lose your data!'} />
                    {this.state.ShowLoader && <Loader
                        wrapperBackgroundColor={'rgba(0, 0, 0, 0.5)'}
                        color={'white'}
                        textStyles={{
                            color: 'white',
                            fontSize: '22px',
                            fontWeight: '500',
                            textShadow: '3px 3px 6px rgb(0 0 0/26%),0 0 5px rgb(15 3 86/22%)'
                        }}
                        fadeIn={true}
                        fullScreen={true}
                        sentences={this.state.LoaderText}/>}
                    <Header
                        NewPageClick={e => this.addNewPage(-1)}
                        InsertPageClick={e => this.addNewPage(1)}
                        ClearClick={this.clearDocument}
                        DeletePageClick={this.deleteNewPage}
                        ZoomIn={e => this.ZoomIn(e)}
                        SetGrid={e => this.SetGrid(e)}
                        ActivePage={this.state.activePage}
                        ActivePageScroll={this.state.activePageScroll}
                        Pages={this.state.Pages}
                        logout={this.logout}
                    />
                    <Container tools={tools} activeElement={activeElement} Pages={this.state.Pages} Doc={this.state.Doc}
                               zoomScale={'scale(' + this.state.scale + ',' + this.state.scale + ')'}
                               scaleNumber={this.state.scale}
                               ZoomIn={e => this.ZoomIn(e)}
                               ResetPage={e => this.resetPage(e)}
                               DeletePageClick={this.deleteNewPage}
                               setFooterText={text => this.setFooterText(text)}
                               onChangeActivePage={(e) => {
                                   this.setState({activePage: e}, () => {
                                   })
                               }
                               }
                               onChangeActivePageScroll={(e) => {
                                   this.setState({activePageScroll: e}, () => {
                                   })
                               }
                               }
                               NewPageClick={e => this.addNewPage(-1)}
                               InsertPageClick={e => this.addNewPage(1)}
                               ShowLoader={(e, text) => this.ShowLoader(e, text)}
                               EditorProps={this.state.EditorProps}
                               EditorPropsChange={e => this.onChangeEditorProps(e)}
                               activePage={this.state.activePage}
                               GridLines={this.state.GridLines}
                               GridSize={this.state.GridSize}
                               ChangeDocName={(e) => this.ChangeDocName(e)}
                    />
                    <Footer
                        scaleNumber={this.state.scale}
                        footerText={this.state.footerText}
                    />
                    <TemplateLibrary />
                    <V2Dashboard />
                </div>
            );
    };
}

const mapStateToProp = state => ({
    tools: state.appReducers.tools,
    activeElement: state.appReducers.activeElement
});
const mapDispatchToProps = {
    initializeApp: loadSettings,
    addPage,
    setPageState,
    changePropertiesById2
};
export default connect(
    mapStateToProp,
    mapDispatchToProps
)(withTranslation()(withRouter(Frame)));
